import { render, staticRenderFns } from "./BtnInserirMeta.vue?vue&type=template&id=4688c878"
import script from "./BtnInserirMeta.vue?vue&type=script&lang=js"
export * from "./BtnInserirMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports